import sha1 from 'sha1'
import axios from 'axios'
import { configGenerator } from './axiosService'
import {
  AUTH_HOST,
  USER_CREDENTIALS,
  USER_SCOPES,
  USER_USER
} from '../config/config'

const TOKEN_URL = AUTH_HOST + '/oauth/token'

// with formdata, and basic auth
async function authPost (url, params, key) {
  const config = configGenerator(window.btoa(key), false, true)

  const data = new window.FormData()
  for (let field in params) {
    if (params.hasOwnProperty(field))
      data.append(field, params[field])
  }

  try {
    const result = await axios.post(url, data, config)

    if (result.status === 200) {
      return result.data
    } else {
      throw new Error('Wrong request for Token: ' + result.status)
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error_description) {
      throw new Error(error.response.data.error_description)
    } else {
      throw error
    }
  }
}

export async function getTokenForClient (clientId, clientSecret, scopes) {
  let params = { grant_type: 'client_credentials' }
  if (scopes) {
    params['scope'] = scopes
  }

  return await authPost(TOKEN_URL, params, clientId + ':' + clientSecret)
}

export async function getTokenForUser (username, password, scopes) {
  let params = {
    grant_type: 'password',
    username: username,
    password: sha1(password)
  }
  if (scopes) {
    params['scope'] = scopes
  }

  return await authPost(TOKEN_URL, params, USER_USER + ':' + USER_CREDENTIALS)
}

async function refreshAuth (token, scopes) {
  let params = {
    grant_type: 'refresh_token',
    refresh_token: token
  }
  if (scopes) {
    params['scope'] = scopes
  }

  return await authPost(TOKEN_URL, params, USER_USER + ':' + USER_CREDENTIALS)
}

export async function validateAuth (auth) {
  if (auth && auth.access_token) {
    const now = new Date()

    if (auth.expires_at && auth.expires_at > now) {
      return auth
    }

    if (auth.refresh_token) {
      try {
        const newAuth = await refreshAuth(auth.refresh_token, USER_SCOPES)

        if (newAuth.expires_in) {
          newAuth.expires_at = new Date(now.getTime() + newAuth.expires_in * 1000)
        }

        if (auth.user) {
          newAuth.user = auth.user
        }

        return newAuth
      } catch (error) {
        throw new Error(error)
      }
    }
  }

  return null
}
